module.exports = __webpack_public_path__ + "static/media/Dashboard.840846ca.png";